<script setup lang="ts">
import { ref } from "vue";
import { XMarkIcon } from '@heroicons/vue/20/solid';

const emits = defineEmits(['close']);
defineProps<{ days: number}>();
</script>
<template>
  <!--
    Make sure you add some bottom padding to pages that include a sticky banner like this to prevent
    your content from being obscured when the user scrolls to the bottom of the page.
  -->
  <div
    v-if="(Number.isInteger(days))"
    class="sticky bottom-0 pointer-events-none sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8"
  >
    <div class="pointer-events-auto shadow-xl flex items-center justify-between gap-x-6 bg-gray-900 px-6 py-2.5 sm:rounded-xl sm:py-3 sm:pl-4 sm:pr-3.5">
      <p class="text-sm leading-6 text-white">
        <span v-if="days > 0">
          <strong class="font-semibold">Délai expiré</strong>
          <svg viewBox="0 0 2 2" class="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
            <circle cx="1" cy="1" r="1" />
          </svg>
          Depuis {{ days }} jours
          <!-- &nbsp;<span aria-hidden="true">&rarr;</span> -->
        </span>
        <span v-else-if="days === 0">
          <strong class="font-semibold">Le délai expire</strong>
          <svg viewBox="0 0 2 2" class="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
            <circle cx="1" cy="1" r="1" />
          </svg>
          Aujourd'hui
        </span>
      </p>
      <button @click="emits('close')" type="button" class="-m-1.5 flex-none p-1.5">
        <span class="sr-only">Fermer</span>
        <XMarkIcon class="w-5 h-5 text-white" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>
